import React from "react";

const MypagePaymentPage = () => {
  return <div>결재 내역 페이지입니다.</div>;
};

export default MypagePaymentPage;
